export default __webpack_public_path__ + "static/media/img-0578-iceland-full-face.086f73f2.png";